export default __webpack_public_path__ + "static/career-collection-card-manufacturing-b14e66433115d2ffc71dc8718719953f.png";